import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import _isEqual from 'lodash/isEqual';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { CloseEyeIcon, deleteDark, eyeIcon, infoIcon, plusIconSimple } from 'assets/icons';
import { toast } from 'react-toastify';
import * as myconst from "../../constants/index"
import { ConfirmDialog } from 'primereact/confirmdialog';
import { InputNumber } from 'primereact/inputnumber';
import { useDispatch, useSelector } from 'react-redux';
import { setUploadPolicyFileName } from 'redux/counterSlice';
import ParamsPopUp from 'components/params/Params-Info-popup';

interface Industry {
    name: string;
    // value: string;
}
interface Item {
    action: Industry;
    prompt?: string;
    tables?: string;
    tables_data?: table_type[];
    product_page_chat_tool_desc?: string;
    feature_column_list_input?: string;
    feature_column_list_output?: string;
    product_recommendation_tool?: string;
    return_policy_tool?: string;
    acceptance_threshold?: number;
    top_n?: number;
    host?: string;
    port?: number;
    username?: string;
    password?: string;
    dialect_database?: string;
    database?: string;
    showPassword?: boolean;
}

interface FormError {
    [key: string]: string;
}

interface table_type {
    table_name: string,
    column_name: string
}
interface StepTwo {
    handlePrev: any;
    handleNext: any;
    methods: any;
    items: Item[];
    setItems: any;
    actionList: Industry[];
    actions: Industry[];
    setTables: Dispatch<SetStateAction<table_type[]>>;
    tables: table_type[]
}
const StepTwo = ({ handlePrev, handleNext, actions, methods, items, setItems, actionList, setTables, tables }: StepTwo) => {
    const { register, getValues, setValue, watch, formState: { errors }, control, trigger, clearErrors, setError, } = useFormContext();
    const dispatch = useDispatch();
    const botRef: any = useRef(null);
    const uploadPolicyFileName = useSelector((state: any) => state.counter.uploadPolicyFileName);
    const industries: Industry[] = [
        { name: "Retail" },
        { name: "Ecommerce" },
        { name: 'Education' },
        // { name: 'Retail', value: "retail" },
        // { name: 'Ecommerce', value: "ecommerce" },
        // { name: 'Education', value: 'education' },
    ];
    const databaseType: Industry[] = [
        { name: "MsSQL" },
        { name: "MySQL" },
        { name: 'PostgreSQL' },
        // { name: 'Retail', value: "retail" },
        // { name: 'Ecommerce', value: "ecommerce" },
        // { name: 'Education', value: 'education' },
    ];
    const [modalContent, setModalContent] = useState<string>('');
    const [errorsOfTable, setErrorsOfTable] = useState<table_type[]>([]);
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const [showPassword, setShowPassword] = useState(false);
    const [formErrors, setFormErrors] = useState<FormError[]>(items.map(() => ({})));
    const [visible, setVisible] = useState<boolean>(false);
    const [del_action, setDel_action] = useState<string>("");
    const [del_index, setDel_index] = useState<number | null>(null);

    const addTableWithColumn = async () => {
        // let isValid: boolean = false;
        // const errorFields = Object.keys(errors);
        // if (errorFields.length > 0) {
        //     const errorField = errorFields[0];
        //     const fieldElement = document.querySelector(`input[name=${errorField}]`);
        //     if (fieldElement) {
        //         (fieldElement as HTMLElement)?.focus();
        //     } else {
        //         console.warn(`Field with name ${errorField} not found`);
        //     }
        // }
        // isValid = await trigger(['tables', 'column'])
        // if (isValid) {
        //     const table = watch('tables');
        //     const column = watch('column');
        //     const finalobj: table_type = {
        //         table_name: table,
        //         column_name: column,
        //     }
        //     setTables([...tables, finalobj]);
        //     setValue('column', '');
        //     setValue('tables', '');
        // }
        const finalobj: table_type = {
            table_name: '',
            column_name: '',
        }
        if (tables.length < 5) {
            setTables([...tables, finalobj])
        }
    }
    const handleChangeTableName = (index: number, key: 'table_name' | 'column_name', value: string) => {
        const updated = [...tables];
        updated[index][key] = value;
        setTables(updated);
        // Clear error for that specific index
        clearErrors(`${key}.${index}`);
        // Clear error on change
        const updatedErrors = [...errorsOfTable];
        if (updatedErrors[index]) {
            updatedErrors[index][key] = '';
            setErrorsOfTable(updatedErrors);
        }
    };

    const removeColmnTable = (column: number) => {
        const newData = tables.filter((table: table_type, index: number) => column !== index);
        setTables(newData);
    }

    // Accordion Functions
    const reject = () => {
        setVisible(false);
        setDel_action("");
    }
    const removeItem = (nameToRemove: string) => {
        const newData = items.filter(item => item.action.name !== nameToRemove).map(item => { return item; });
        if (del_index === activeIndex) {
            setActiveIndex(null)
            setDel_index(null)
        }
        if (nameToRemove === "Policy Tool") {
            setValue("upload_policy_file", "");
            dispatch(setUploadPolicyFileName(""))
        }
        if (nameToRemove === "Login Tool") {
            const finalobj: table_type = {
                table_name: '',
                column_name: '',
            }
            setTables([finalobj])
            setValue('column', '');
            setValue('tables', '');
        }
        setItems(newData);
        setDel_action("");
    };
    const headerTemplate = (tab: any) => {
        const { className, title, index } = tab;
        const isActive = activeIndex === index;
        const iconClassName = isActive ? 'pi pi-minus' : 'pi pi-plus';
        const handleIconClick = (e: React.MouseEvent) => {
            setActiveIndex(isActive ? null : index);
        };
        const handleHeaderClick = (e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
        };
        return (
            <div className={`${className} acc-form-header`}>
                <span>Action: <b>{title}</b></span>
                <span className='acc-right-action' onClick={handleHeaderClick}>
                    <i className={iconClassName} onClick={handleIconClick} style={{ cursor: 'pointer' }}></i>
                    <i className='pi pi-trash' style={{ cursor: 'pointer' }} onClick={() => { setVisible(true); setDel_action(title); setDel_index(index); }}></i>
                </span>
            </div>
        );
    };
    const onTabChange = (e: any) => {
        setActiveIndex(e.index);
    };

    const handleAddAction = async () => {
        let isValid: boolean = false;
        const errorFields = Object.keys(errors);
        if (errorFields.length > 0) {
            const errorField = errorFields[0];
            const fieldElement = document.querySelector(`input[name=${errorField}]`);
            if (fieldElement) {
                (fieldElement as HTMLElement)?.focus();
            } else {
                console.warn(`Field with name ${errorField} not found`);
            }
        }

        const validationErrors = tables.map((item) => {
            return {
                table_name: item.table_name.trim() === '' ? 'Table name is required' : '',
                column_name: item.column_name.trim() === '' ? 'Column name is required' : '',
            };
        });

        setErrorsOfTable(validationErrors);

        const hasErrors = validationErrors.some(
            (err) => err.table_name || err.column_name
        );

        const action = getValues("action");
        if (action?.name === "Policy Tool") {
            isValid = await trigger(['industry', 'action', 'product_page_chat_tool_desc', 'return_policy_tool', 'upload_policy_file']);
            if (isValid) {
                const itemObject = {} as Item
                itemObject.action = getValues("action");
                itemObject.product_page_chat_tool_desc = getValues("product_page_chat_tool_desc");
                itemObject.return_policy_tool = getValues("return_policy_tool");
                setItems([...items, itemObject])
                setValue("action", undefined)
                setValue("product_page_chat_tool_desc", "")
                setValue("return_policy_tool", undefined)
            }
        } else if (actionName?.name === "Login Tool") {
            isValid = await trigger(['industry', 'action', 'prompt', 'host', 'port', 'username', 'password', 'dialect_database', 'database', 'column_name', 'table_name']);
            if (isValid && !hasErrors) {
                const itemObject = {} as Item
                itemObject.action = getValues("action");
                itemObject.prompt = getValues("prompt");
                itemObject.host = getValues("host");
                itemObject.port = getValues("port");
                itemObject.tables_data = tables;
                itemObject.username = getValues("username");
                itemObject.password = getValues("password");
                itemObject.dialect_database = getValues("dialect_database");
                itemObject.database = getValues("database");
                setItems([...items, itemObject])
                setValue("action", undefined)
                setValue("prompt", "")
                setValue("host", undefined);
                setValue("port", "");
                setValue("username", undefined);
                setValue("password", undefined);
                setValue("dialect_database", undefined);
                setValue("database", undefined);
                setValue('column', '');
                setValue('tables', '');
            }
        } else if (action?.name !== "Faq Tool" && action?.name !== "Product Search and Recommendation") {
            isValid = await trigger(['industry', 'action', 'prompt', 'host', 'port', 'username', 'password', 'dialect_database', 'database', 'tables']);
            if (isValid) {
                const itemObject = {} as Item
                itemObject.action = getValues("action");
                itemObject.prompt = getValues("prompt");
                itemObject.host = getValues("host");
                itemObject.port = getValues("port");
                itemObject.tables = getValues("tables");
                itemObject.username = getValues("username");
                itemObject.password = getValues("password");
                itemObject.dialect_database = getValues("dialect_database");
                itemObject.database = getValues("database");
                setItems([...items, itemObject])
                setValue("action", undefined)
                setValue("prompt", "")
                setValue("host", undefined);
                setValue("port", "");
                setValue("tables", "");
                setValue("username", undefined);
                setValue("password", undefined);
                setValue("dialect_database", undefined);
                setValue("database", undefined);
            }
        } else if (action?.name !== "Faq Tool" && action?.name === "Product Search and Recommendation") {
            isValid = await trigger(['industry', 'action', 'prompt', 'host', 'port', 'username', 'password', 'dialect_database', 'database', 'tables', 'feature_column_list_input', 'feature_column_list_output', 'acceptance_threshold', 'top_n', 'product_recommendation_tool']);
            if (isValid) {
                const itemObject = {} as Item
                itemObject.action = getValues("action");
                itemObject.prompt = getValues("prompt");
                itemObject.host = getValues("host");
                itemObject.port = getValues("port");
                itemObject.tables = getValues("tables");
                itemObject.username = getValues("username");
                itemObject.password = getValues("password");
                itemObject.dialect_database = getValues("dialect_database");
                itemObject.database = getValues("database");
                itemObject.feature_column_list_input = getValues("feature_column_list_input");
                itemObject.feature_column_list_output = getValues("feature_column_list_output");
                itemObject.top_n = getValues("top_n");
                itemObject.product_recommendation_tool = getValues("product_recommendation_tool");
                itemObject.acceptance_threshold = getValues("acceptance_threshold");
                setItems([...items, itemObject])
                setValue("action", undefined)
                setValue("prompt", "")
                setValue("host", undefined);
                setValue("port", "");
                setValue("tables", "");
                setValue("username", undefined);
                setValue("password", undefined);
                setValue("dialect_database", undefined);
                setValue("database", undefined);
                setValue("feature_column_list_input", undefined);
                setValue("feature_column_list_output", undefined);
                setValue("top_n", undefined);
                setValue("product_recommendation_tool", undefined);
                setValue("acceptance_threshold", undefined);
            }
        } else {
            isValid = await trigger(['industry', 'action', 'prompt']);
            if (isValid) {
                const itemObject = {} as Item
                itemObject.action = getValues("action");
                itemObject.prompt = getValues("prompt");
                setItems([...items, itemObject])
                setValue("action", undefined)
                setValue("prompt", "")
            }
        }
    }
    const getFormErrorMessage = (name: string) => {
        return (
            errors[name] && (
                <small className="p-error">{errors[name]?.message?.toString()}</small>
            )
        )
    }

    const actionName = watch("action");
    useEffect(() => {
        switch (actionName?.name) {
            case 'Product Search and Recommendation':
                setValue("prompt", myconst.product_search);
                setValue("product_recommendation_tool", myconst.product_recommendation_tool);
                break;
            case 'Login Tool':
                setValue("prompt", myconst.login_tool);
                break;
            case 'Faq Tool':
                setValue("prompt", myconst.faq_tool);
                break;
            case 'Other Tool':
                setValue("prompt", myconst.other_tool);
                break;
            case 'Policy Tool':
                setValue("product_page_chat_tool_desc", myconst.product_page_chat_tool_desc);
                setValue("return_policy_tool", myconst.return_policy_tool);
                break;
            default:
                setValue("prompt", "");
                break;
        }
    }, [actionName])
    const hasHostKey = items.some(obj => 'host' in obj);

    const validateInput = (index: number, key: string) => {
        let error = '';
        const newFormErrors: any = [...formErrors];
        if (!newFormErrors[index]) {
            newFormErrors[index] = {};
        }

        newFormErrors[index][key] = error;
        setFormErrors(newFormErrors);
    };
    const handleChange = (e: any, actionName: string, index: number, field: string) => {
        setItems((prevItems: any) => {
            return prevItems.map((item: any) => {
                if (item.action.name === actionName) {
                    if (field === 'dialect_database') {
                        if (actionName === 'Login Tool') {
                            setTables([{
                                table_name: "",
                                column_name: ""
                            }])
                            return {
                                ...item,
                                dialect_database: e.target.value,
                                database: "",
                                host: "",
                                port: "",
                                username: "",
                                password: "",
                            };
                        } else {
                            return {
                                ...item,
                                dialect_database: e.target.value,
                                database: "",
                                host: "",
                                port: "",
                                username: "",
                                password: "",
                                tables: "",
                            };
                        }
                    } else if (field === 'showPassword') {
                        return {
                            ...item,
                            [field]: !e
                        }
                    }
                    return { ...item, [field]: e.target.value };
                }
                return item;
            });
        });
        validateInput(index, field);
    };
    const handleErrorName = (key: String, actionName: string) => {
        switch (key) {
            case 'tables':
                return 'Table Name';
            case 'product_page_chat_tool_desc':
                return 'Product Page Chat Prompt';
            case 'product_recommendation_tool':
                return 'Product Recommendation Prompt';
            case 'return_policy_tool':
                return 'Return and Shipping Policy Prompt';
            case 'feature_column_list_input':
                return 'Column Input List';
            case 'feature_column_list_output':
                return 'Column Output List';
            case 'top_n':
                return 'Max Search Results';
            case 'acceptance_threshold':
                return 'Acceptance Threshold';
            default:
                return actionName === "Product Search and Recommendation" && key === "prompt" ? "Product Search Prompt" : key.charAt(0).toUpperCase() + key.slice(1);
        }
    }
    const validateTableFields = () => {
        const updatedErrors = tables.map((table) => ({
            table_name: table.table_name.trim() === '' ? 'Table Name is required' : '',
            column_name: table.column_name.trim() === '' ? 'Column Name is required' : '',
        }));
        setErrorsOfTable(updatedErrors);

        // Return true if all fields are valid
        return updatedErrors.every((err) => !err.table_name && !err.column_name);
    };
    const handleNextButton = async () => {
        const exists = items.some(item => item.action?.name === "Login Tool");
        // if (exists) {
        //     if (!validateTableFields()) return;
        // }
        let valid = true;
        const errorFields = Object.keys(errors);
        if (errorFields.length > 0) {
            const errorField = errorFields[0];
            const fieldElement = document.querySelector(`input[name=${errorField}]`);
            if (fieldElement) {
                (fieldElement as HTMLElement)?.focus();
            } else {
                console.warn(`Field with name ${errorField} not found`);
            }
        }
        const newErrors: any = items.map(() => ({} as FormError));
        items.forEach((item, index) => {
            Object.keys(item).forEach(key => {
                let value = item[key as keyof Item] as string;
                if (key === 'tables' && (item?.action?.name === 'Faq Tool' || item?.action?.name === "Policy Tool")) {
                    return;
                }
                if ((key === 'return_policy_tool' || key === 'product_page_chat_tool_desc') && item?.action?.name !== "Policy Tool") {
                    return;
                }
                if ((key === 'product_recommendation_tool' || key === 'feature_column_list_input' || key === "feature_column_list_output" || key === "top_n" || key === "acceptance_threshold") && item?.action?.name !== "Product Search and Recommendation") {
                    return;
                }
                if (!value && key !== "showPassword") {
                    newErrors[index][key] = `${handleErrorName(key, item.action.name)} is required`;
                    valid = false;
                }
                if (key === 'acceptance_threshold' && item?.action?.name === "Product Search and Recommendation") {
                    if (Number(value) < 0 || Number(value) > 1) {
                        newErrors[index][key] = 'Acceptance Threshold must be between 0 and 1'
                        valid = false;
                    } else if (typeof value === 'string' && value?.startsWith('.')) {
                        (item as any)['acceptance_threshold'] = `0${value}`
                    } else {
                        return;
                    }
                }
                if (key === 'top_n' && item?.action?.name === "Product Search and Recommendation") {
                    if (value !== '' && (Number(value) < 1 || Number(value) > 20)) {
                        newErrors[index][key] = 'Max Search Results must be between 1 and 20'
                        valid = false;
                    } else {
                        return;
                    }
                }
            });
        });
        setFormErrors(newErrors);
        if (exists) {
            if (!validateTableFields()) return;
        }
        if (items.length > 0) {
            if (valid) {
                handleNext();
            }
        } else {
            toast.error("Please add atleast one action", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const handleCustomChange = (e: React.ChangeEvent<HTMLTextAreaElement>, field: any, fieldName: string) => {
        field.onChange(e);
        clearErrors(fieldName);
    };

    return (
        <div className='stepper-main stepper-step-2'>
            <div className='stepper-form'>
                <div className='stepper-top'>
                    <div className='stepper-wrapper'>
                        <div className='form-row'>
                            <div className='form-col'>
                                <label className="form-label">
                                    Select Industry
                                    {/* Select Industry<i>*</i> */}
                                </label>
                                <Controller
                                    name="industry"
                                    control={methods.control}
                                    rules={{
                                        required: "Industry is required"
                                    }}
                                    // defaultValue={apiData.fontSize}
                                    render={({ field }) => (
                                        <Dropdown
                                            {...field}
                                            id="yourDropdownId" // Replace with your desired ID
                                            options={industries}
                                            value={field.value}
                                            optionLabel="name"
                                            disabled
                                            onChange={(e) => setValue("industry", e.target.value, { shouldValidate: true })}
                                            placeholder="Select Industry"
                                            className={`bot-dropdown`}
                                        />
                                    )}
                                />
                                {getFormErrorMessage("industry")}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='stepper-middle'>
                    <Accordion activeIndex={activeIndex} onTabChange={onTabChange}>
                        {items?.map((item, index) => (
                            <AccordionTab
                                key={item?.action?.name}
                                headerTemplate={(options) => headerTemplate({ ...options, title: item?.action?.name, index })}
                                header={item?.action?.name}
                            >
                                <div className='stepper-border'>
                                    <div className='stepper-wrapper'>
                                        <div className='form-row'>
                                            <div className='form-col'>
                                                <label className="form-label">Action<i>*</i></label>
                                                <Dropdown
                                                    id="yourDropdownId"
                                                    options={actions}
                                                    value={item.action}
                                                    optionLabel="name"
                                                    placeholder="Select Action"
                                                    className={`bot-dropdown`}
                                                    disabled
                                                />
                                                <div className='field-info'><i className='pi pi-info-circle'></i>{item?.action?.name === "Faq Tool" ? "Unstructured" : "Structured"} Dataset</div>
                                            </div>
                                            {item.action.name === "Policy Tool" ?
                                                <div className='form-col'>
                                                    <label className="form-label">Product Page Chat Prompt<i>*</i></label>
                                                    <InputTextarea style={{ border: formErrors[index]?.product_page_chat_tool_desc ? '1px solid #EC292E' : '' }} value={item?.product_page_chat_tool_desc} onChange={(e) => handleChange(e, item?.action?.name, index, 'product_page_chat_tool_desc')} />
                                                    {formErrors[index]?.product_page_chat_tool_desc && <small className="p-error">{formErrors[index]?.product_page_chat_tool_desc}</small>}
                                                </div>
                                                :
                                                <div className='form-col'>
                                                    <label className="form-label">{item.action.name === "Product Search and Recommendation" ? 'Product Search Prompt' : 'Prompt'}<i>*</i></label>
                                                    <InputTextarea style={{ border: formErrors[index]?.prompt ? '1px solid #EC292E' : '' }} value={item?.prompt} onChange={(e) => handleChange(e, item?.action?.name, index, 'prompt')} />
                                                    {formErrors[index]?.prompt && <small className="p-error">{formErrors[index]?.prompt}</small>}
                                                </div>
                                            }
                                        </div>
                                        {item.action.name !== "Faq Tool" && item.action.name !== "Policy Tool" && <>
                                            <div className='form-row'>
                                                <div className='form-col'>
                                                    <label className="form-label">Host<i>*</i></label>
                                                    <InputText style={{ border: formErrors[index]?.host ? '1px solid #EC292E' : '' }} value={item?.host} onChange={(e) => handleChange(e, item?.action?.name, index, 'host')} />
                                                    {formErrors[index]?.host && <small className="p-error">{formErrors[index]?.host}</small>}
                                                </div>
                                                <div className='form-col'>
                                                    <label className="form-label">Port<i>*</i></label>
                                                    <InputText style={{ border: formErrors[index]?.port ? '1px solid #EC292E' : '' }} value={item?.port as any} onChange={e => { if (e.target.value.length <= 4 && /^\d*$/.test(e.target.value)) { handleChange(e, item?.action?.name, index, 'port') } }} />
                                                    {formErrors[index]?.port && <small className="p-error">{formErrors[index]?.port}</small>}
                                                </div>
                                            </div>
                                            <div className='form-row'>
                                                <div className='form-col'>
                                                    <label className="form-label">User Name<i>*</i></label>
                                                    <InputText style={{ border: formErrors[index]?.username ? '1px solid #EC292E' : '' }} value={item?.username} onChange={(e) => handleChange(e, item?.action?.name, index, 'username')} />
                                                    {formErrors[index]?.username && <small className="p-error">{formErrors[index]?.username}</small>}
                                                </div>
                                                <div className='form-col'>
                                                    <label className="form-label">Password<i>*</i></label>
                                                    <div className='d-flex align-items-center position-relative'>
                                                        <InputText style={{ border: formErrors[index]?.password ? '1px solid #EC292E' : '' }} className='passowrd-padding' type={item?.showPassword ? "text" : "password"} value={item?.password} onChange={(e) => handleChange(e, item?.action?.name, index, 'password')} />
                                                        <span className={`password-toggle3`} onClick={() => handleChange(item?.showPassword, item?.action?.name, index, 'showPassword')}>
                                                            {!item?.showPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                                                                <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                                                            }
                                                        </span>
                                                    </div>
                                                    {formErrors[index]?.password && <small className="p-error">{formErrors[index]?.password}</small>}
                                                </div>
                                            </div>
                                            <div className='form-row'>
                                                <div className='form-col'>
                                                    <label className="form-label">Dialect Database<i>*</i></label>
                                                    <Dropdown
                                                        id="yourDropdownId" // Replace with your desired ID
                                                        options={databaseType}
                                                        value={item?.dialect_database}
                                                        optionLabel="name"
                                                        onChange={(e) => handleChange(e, item?.action?.name, index, 'dialect_database')}
                                                        placeholder="Select Database Type"
                                                        className={`bot-dropdown`}
                                                    />
                                                </div>
                                                <div className='form-col'>
                                                    <label className="form-label">Database Name<i>*</i></label>
                                                    <InputText style={{ border: formErrors[index]?.database ? '1px solid #EC292E' : '' }} autoComplete="new-password" value={item?.database} onChange={(e) => handleChange(e, item?.action?.name, index, 'database')} />
                                                    {formErrors[index]?.database && <small className="p-error">{formErrors[index]?.database}</small>}
                                                </div>
                                            </div>
                                            {item.action.name === "Login Tool" ?
                                                <>
                                                    {tables.map((table: table_type, index: number) => (

                                                        <div className='form-row multi-row' key={index}>
                                                            <div className="form-col">
                                                                <label className="form-label">Table Name<i>*</i></label>
                                                                <InputText
                                                                    type="text"
                                                                    value={table.table_name}
                                                                    onChange={(e) => handleChangeTableName(index, 'table_name', e.target.value)}
                                                                    style={{ border: errorsOfTable[index]?.table_name ? '1px solid #EC292E' : '' }}
                                                                />
                                                                {errorsOfTable[index]?.table_name && (
                                                                    <small style={{ color: '#EC292E', fontSize: '12px' }}>{errorsOfTable[index].table_name}</small>
                                                                )}
                                                            </div>
                                                            <div className="form-col">
                                                                <label className="form-label">Column Name<i>*</i></label>
                                                                <InputText
                                                                    type="text"
                                                                    value={table.column_name}
                                                                    onChange={(e) => handleChangeTableName(index, 'column_name', e.target.value)}
                                                                    style={{ border: errorsOfTable[index]?.column_name ? '1px solid #EC292E' : '' }}
                                                                />
                                                                {errorsOfTable[index]?.column_name && (
                                                                    <small style={{ color: '#EC292E', fontSize: '12px' }}>{errorsOfTable[index].column_name}</small>
                                                                )}
                                                            </div>
                                                            {index === 0 &&
                                                                <i
                                                                    className="row-action c-pointer"
                                                                    onClick={addTableWithColumn}
                                                                    style={{ pointerEvents: tables.length < 5 ? 'visible' : 'none', opacity: tables.length === 5 ? '0.5' : '' }}
                                                                >
                                                                    <img src={plusIconSimple} alt='plus-icon' />
                                                                </i>
                                                            }
                                                            {index !== 0 && <i className="row-action-del c-pointer" onClick={() => removeColmnTable(index)}>
                                                                <img src={deleteDark} alt='delete-icon' />
                                                            </i>}
                                                        </div>
                                                    ))}
                                                </>
                                                :
                                                <div className='form-row'>
                                                    <div className='form-col'>
                                                        <label className="form-label">Table Name<i>*</i></label>
                                                        <InputText style={{ border: formErrors[index]?.tables ? '1px solid #EC292E' : '' }} autoComplete="new-password" placeholder='Ex. table1,table2' value={item?.tables?.trim()} onChange={(e) => handleChange(e, item?.action?.name, index, 'tables')} />
                                                        {formErrors[index]?.tables && <small className="p-error">{formErrors[index]?.tables}</small>}
                                                    </div>
                                                    {item.action.name === "Product Search and Recommendation" &&
                                                        <div className='form-col'>
                                                            <label className="form-label">
                                                                Column Input List
                                                                <i>*</i>
                                                                <i
                                                                    data-bs-toggle="modal"
                                                                    className='ms-2'
                                                                    data-bs-target="#Params-Info"
                                                                    onClick={() => setModalContent("Defines the columns utilized as input features for generating embeddings, for example, productID.")}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <img src={infoIcon} alt='info-icon' style={{ width: "16px" }} />
                                                                </i>
                                                            </label>
                                                            <InputText style={{ border: formErrors[index]?.feature_column_list_input ? '1px solid #EC292E' : '' }} autoComplete="new-password" placeholder='Ex. column1,column2' value={item?.feature_column_list_input?.trim()} onChange={(e) => handleChange(e, item?.action?.name, index, 'feature_column_list_input')} />
                                                            {formErrors[index]?.feature_column_list_input && <small className="p-error">{formErrors[index]?.feature_column_list_input}</small>}
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {/* {item.action.name === "Login Tool" && tables.length > 0 && tables.map((table: table_type, index: number) => (
                                                <div className='form-row multi-row' key={index}>
                                                    <div className="form-col">
                                                        <InputText
                                                            autoComplete="new-password"
                                                            value={table.table_name}
                                                            onChange={(e) => handleChangeTableName(index, 'table_name', e.target.value)}
                                                            placeholder='Enter your table name'
                                                        />
                                                        {errorsOfTable[index]?.table_name && (
                                                            <div style={{ color: 'red', fontSize: '14px' }}>{errorsOfTable[index].table_name}</div>
                                                        )}
                                                    </div>
                                                    <div className="form-col">
                                                        <InputText
                                                            autoComplete="new-password"
                                                            value={table.column_name}
                                                            onChange={(e) => handleChangeTableName(index, 'column_name', e.target.value)}
                                                            placeholder='Enter your column name'
                                                        />
                                                        {errorsOfTable[index]?.column_name && (
                                                            <div style={{ color: 'red', fontSize: '14px' }}>{errorsOfTable[index].column_name}</div>
                                                        )}
                                                    </div>
                                                    <i className="row-action-del c-pointer" onClick={() => removeColmnTable(index)}>
                                                        <img src={deleteDark} alt='delete-icon' />
                                                    </i>
                                                </div>
                                            ))} */}
                                            {item.action.name === "Product Search and Recommendation" &&
                                                <>
                                                    <div className='form-row'>
                                                        <div className='form-col'>
                                                            <label className="form-label">
                                                                Column Output List
                                                                <i>*</i>
                                                                <i
                                                                    data-bs-toggle="modal"
                                                                    className='ms-2'
                                                                    data-bs-target="#Params-Info"
                                                                    onClick={() => setModalContent("Specifies the columns to be displayed in the UI, such as product details or ratings.")}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <img src={infoIcon} alt='info-icon' style={{ width: "16px" }} />
                                                                </i>
                                                            </label>
                                                            <InputText style={{ border: formErrors[index]?.feature_column_list_output ? '1px solid #EC292E' : '' }} autoComplete="new-password" placeholder='Ex. column1,column2' value={item?.feature_column_list_output?.trim()} onChange={(e) => handleChange(e, item?.action?.name, index, 'feature_column_list_output')} />
                                                            {formErrors[index]?.feature_column_list_output && <small className="p-error">{formErrors[index]?.feature_column_list_output}</small>}
                                                        </div>
                                                        <div className='form-col'>
                                                            <label className="form-label">Acceptance Threshold<i>*</i>
                                                                <i
                                                                    data-bs-toggle="modal"
                                                                    className='ms-2'
                                                                    data-bs-target="#Params-Info"
                                                                    onClick={() => setModalContent("Determines the quality or relevance of results, e.g., 0.75.")}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <img src={infoIcon} alt='info-icon' style={{ width: "16px" }} />
                                                                </i>
                                                            </label>
                                                            <InputText style={{ border: formErrors[index]?.acceptance_threshold ? '1px solid #EC292E' : '' }} autoComplete="new-password" value={item?.acceptance_threshold as any} onChange={(e) => { if (/^-?\d*\.?\d*$/.test(e.target.value)) { handleChange(e, item?.action?.name, index, 'acceptance_threshold') } }} />
                                                            {formErrors[index]?.acceptance_threshold && <small className="p-error">{formErrors[index]?.acceptance_threshold}</small>}
                                                        </div>
                                                    </div>
                                                    <div className='form-row'>
                                                        <div className='form-col'>
                                                            <label className="form-label">Product Recommendation Prompt<i>*</i></label>
                                                            <InputTextarea style={{ border: formErrors[index]?.product_recommendation_tool ? '1px solid #EC292E' : '' }} value={item?.product_recommendation_tool} onChange={(e) => handleChange(e, item?.action?.name, index, 'product_recommendation_tool')} />
                                                            {formErrors[index]?.product_recommendation_tool && <small className="p-error">{formErrors[index]?.product_recommendation_tool}</small>}
                                                        </div>
                                                        <div className='form-col'>
                                                            <label className="form-label">
                                                                Max Search Results
                                                                <i>*</i>
                                                                <i
                                                                    data-bs-toggle="modal"
                                                                    className='ms-2'
                                                                    data-bs-target="#Params-Info"
                                                                    onClick={() => setModalContent("Indicates the number of top results to return, e.g., 6.")}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <img src={infoIcon} alt='info-icon' style={{ width: "16px" }} />
                                                                </i>
                                                            </label>
                                                            <InputText style={{ border: formErrors[index]?.top_n ? '1px solid #EC292E' : '' }} autoComplete="new-password" value={item?.top_n as any} onChange={(e) => { if (/^\d*$/.test(e.target.value)) { handleChange(e, item?.action?.name, index, 'top_n') } }} />
                                                            {formErrors[index]?.top_n && <small className="p-error">{formErrors[index]?.top_n}</small>}
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </>}
                                        {item.action.name === "Policy Tool" &&
                                            <div className='form-row'>
                                                <div className='form-col'>
                                                    <label className="form-label">Return and Shipping Policy Prompt<i>*</i></label>
                                                    <InputTextarea style={{ border: formErrors[index]?.return_policy_tool ? '1px solid #EC292E' : '' }} value={item?.return_policy_tool} onChange={(e) => handleChange(e, item?.action?.name, index, 'return_policy_tool')} />
                                                    {formErrors[index]?.return_policy_tool && <small className="p-error">{formErrors[index]?.return_policy_tool}</small>}
                                                </div>
                                                <div className='form-col'>
                                                    <label className="form-label">Policy File<i>*</i></label>
                                                    <div className="form-field-wrap">
                                                        <button type="button" className="file-btn" onClick={() => botRef.current.click()}>Choose File</button>
                                                        <span className="file-label" title={uploadPolicyFileName}>{uploadPolicyFileName === "" ? "No file Chosen" : uploadPolicyFileName}</span>
                                                        <Controller
                                                            name="upload_policy_file"
                                                            control={control}
                                                            defaultValue={[]}
                                                            rules={{
                                                                validate: {
                                                                    required: (files) => files.length > 0 || "Policy File is required",
                                                                },
                                                            }}
                                                            render={({ field }) => (
                                                                <input
                                                                    type="file"
                                                                    accept=".pdf,.doc,.docx"
                                                                    onChange={async (e: any) => {
                                                                        clearErrors("upload_policy_file");
                                                                        if (e?.target?.files[0]) {
                                                                            if (["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(e?.target?.files[0]?.type)) {
                                                                                if (e?.target?.files[0].size < 5 * 1024 * 1024) {
                                                                                    const base64Code: any = await myconst.fileToBase64(e?.target?.files[0])
                                                                                    const correctBase64 = await myconst.manipulateBase64Data(base64Code);
                                                                                    setValue("upload_policy_file", correctBase64);
                                                                                    dispatch(setUploadPolicyFileName(e?.target?.files[0].name))
                                                                                    field.onChange(correctBase64); // Update Controller state
                                                                                } else {
                                                                                    botRef.current.value = null;
                                                                                    toast.error("Policy File size must be less than 5MB", {
                                                                                        style: {
                                                                                            backgroundColor: '#F1F1F1', // Grey background
                                                                                        }
                                                                                    })
                                                                                }
                                                                            } else {
                                                                                toast.error("Only PDF or DOCX files are allowed", {
                                                                                    style: {
                                                                                        backgroundColor: '#F1F1F1', // Grey background
                                                                                    }
                                                                                })
                                                                                botRef.current.value = "";
                                                                            }
                                                                        }
                                                                    }}
                                                                    ref={botRef}
                                                                    id="botLogo"
                                                                    className="d-none"
                                                                    multiple={false} // Optional: Allow only one file
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                    {getFormErrorMessage("upload_policy_file")}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </AccordionTab>
                        ))}
                    </Accordion>
                </div>
                {actionList.length > 0 &&
                    <div className='stepper-body'>
                        <div className='stepper-border-inner'>
                            <div className='stepper-wrapper'>
                                <div className='form-row'>
                                    <div className='form-col'>
                                        <label className="form-label">Action<i>*</i></label>
                                        <Controller
                                            name="action"
                                            control={methods.control}
                                            rules={{
                                                required: "Action is required"
                                            }}
                                            render={({ field }) => (
                                                <Dropdown
                                                    {...field}
                                                    id="yourDropdownId" // Replace with your desired ID
                                                    options={actionList}
                                                    value={field.value}
                                                    optionLabel="name"
                                                    style={{ border: errors.action ? '1px solid #EC292E' : '' }}
                                                    onChange={(e) => { setValue("action", e.target.value, { shouldValidate: true }); setValue("tables", ""); clearErrors() }}
                                                    placeholder="Select Action"
                                                    className={`bot-dropdown`}
                                                />
                                            )}
                                        />
                                        {getFormErrorMessage("action")}
                                    </div>
                                    {actionName?.name === "Policy Tool" ?
                                        <div className='form-col'>
                                            <label className="form-label">Product Page Chat Prompt<i>*</i></label>
                                            <Controller
                                                name={`product_page_chat_tool_desc`}
                                                control={control}
                                                defaultValue=""
                                                rules={{
                                                    required: "Product Page Chat Prompt is required"
                                                }}
                                                render={({ field }) => (
                                                    <InputTextarea
                                                        {...field}
                                                        style={{ border: errors.product_page_chat_tool_desc ? '1px solid #EC292E' : '' }}
                                                        onChange={(e) => handleCustomChange(e, field, "product_page_chat_tool_desc")}
                                                    />
                                                )}
                                            />
                                            {getFormErrorMessage(`product_page_chat_tool_desc`)}
                                        </div>
                                        :
                                        <div className='form-col'>
                                            <label className="form-label">Prompt<i>*</i></label>
                                            <Controller
                                                name={`prompt`}
                                                control={control}
                                                defaultValue=""
                                                rules={{
                                                    required: "Prompt is required"
                                                }}
                                                render={({ field }) => (
                                                    <InputTextarea
                                                        {...field}
                                                        onChange={(e) => handleCustomChange(e, field, "prompt")}
                                                        style={{ border: errors.prompt ? '1px solid #EC292E' : '' }}
                                                    />
                                                )}
                                            />
                                            {getFormErrorMessage(`prompt`)}
                                        </div>
                                    }
                                </div>
                                {actionName?.name !== "Faq Tool" && actionName?.name !== "Policy Tool" &&
                                    <>
                                        <div className='form-row'>
                                            <div className='form-col'>
                                                <label className="form-label">Host<i>*</i></label>
                                                <Controller
                                                    name={`host`}
                                                    control={control}
                                                    defaultValue=""
                                                    rules={{
                                                        required: "Host is required"
                                                    }}
                                                    render={({ field }) => (
                                                        <InputText
                                                            {...field}
                                                            autoComplete="new-password"
                                                            placeholder="Enter your Host"
                                                            style={{ border: errors.host ? '1px solid #EC292E' : '' }}
                                                            onChange={e => { setValue("host", e.target.value); clearErrors("host") }}
                                                        />
                                                    )}
                                                />
                                                {getFormErrorMessage(`host`)}
                                            </div>
                                            <div className='form-col'>
                                                <label className="form-label">Port<i>*</i></label>
                                                <Controller
                                                    name={`port`}
                                                    control={control}
                                                    defaultValue=""
                                                    rules={{
                                                        required: "Port is required",
                                                        maxLength: {
                                                            value: 4,
                                                            message: 'Max length of Port is 4 digits'
                                                        }
                                                    }}
                                                    render={({ field }) => (
                                                        <InputText
                                                            {...field}
                                                            onWheel={(e: any) => e.target.blur()}
                                                            style={{ border: errors.port ? '1px solid #EC292E' : '' }}
                                                            type='number'
                                                            autoComplete="new-password"
                                                            placeholder="Enter your Port"
                                                            onChange={e => { setValue("port", e.target.value); clearErrors("port") }}
                                                        />
                                                    )}
                                                />
                                                {getFormErrorMessage(`port`)}
                                            </div>
                                        </div>
                                        <div className='form-row'>
                                            <div className='form-col'>
                                                <label className="form-label">User Name<i>*</i></label>
                                                <Controller
                                                    name={`username`}
                                                    control={control}
                                                    defaultValue=""
                                                    rules={{
                                                        required: "Username is required"
                                                    }}
                                                    render={({ field }) => (
                                                        <InputText
                                                            {...field}
                                                            autoComplete="new-password"
                                                            style={{ border: errors.username ? '1px solid #EC292E' : '' }}
                                                            placeholder="Enter your Username"
                                                            onChange={e => { setValue("username", e.target.value); clearErrors("username") }}
                                                        />
                                                    )}
                                                />
                                                {getFormErrorMessage(`username`)}
                                            </div>
                                            <div className='form-col'>
                                                <label className="form-label">Password<i>*</i></label>
                                                <div className='d-flex align-items-center position-relative'>
                                                    <Controller
                                                        name={`password`}
                                                        control={control}
                                                        defaultValue=""
                                                        rules={{
                                                            required: "Password is required"
                                                        }}
                                                        render={({ field }) => (
                                                            <InputText
                                                                autoComplete="new-password"
                                                                className='passowrd-padding'
                                                                type={showPassword ? "text" : "password"}
                                                                {...field}
                                                                style={{ border: errors.password ? '1px solid #EC292E' : '' }}
                                                                placeholder="Enter your Password"
                                                                onChange={e => { setValue("password", e.target.value); clearErrors("password") }}
                                                            />
                                                        )}
                                                    />
                                                    <span className={`password-toggle3`} onClick={() => setShowPassword(!showPassword)}>
                                                        {!showPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                                                            <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                                                        }
                                                    </span>
                                                </div>
                                                {getFormErrorMessage("password")}
                                            </div>
                                        </div>
                                        <div className='form-row'>
                                            <div className='form-col'>
                                                <label className="form-label">Dialect Database<i>*</i></label>
                                                <Controller
                                                    name="dialect_database"
                                                    control={methods.control}
                                                    rules={{
                                                        required: "Dialect Database is required"
                                                    }}
                                                    render={({ field }) => (
                                                        <Dropdown
                                                            {...field}
                                                            id="yourDropdownId" // Replace with your desired ID
                                                            options={databaseType}
                                                            value={field.value}
                                                            optionLabel="name"
                                                            style={{ border: errors.dialect_database ? '1px solid #EC292E' : '' }}
                                                            onChange={(e) => { setValue("dialect_database", e.target.value, { shouldValidate: true }); }}
                                                            placeholder="Select Database Type"
                                                            className={`bot-dropdown`}
                                                        />
                                                    )}
                                                />
                                                {getFormErrorMessage("dialect_database")}
                                            </div>
                                            <div className='form-col'>
                                                <label className="form-label">Database Name<i>*</i></label>
                                                <Controller
                                                    name={`database`}
                                                    control={control}
                                                    defaultValue=""
                                                    rules={{
                                                        required: "Database is required"
                                                    }}
                                                    render={({ field }) => (
                                                        <InputText
                                                            {...field}
                                                            autoComplete="new-password"
                                                            placeholder="Enter your Database"
                                                            style={{ border: errors.database ? '1px solid #EC292E' : '' }}
                                                            onChange={e => { setValue("database", e.target.value); clearErrors("database") }}
                                                        />
                                                    )}
                                                />
                                                {getFormErrorMessage("database")}
                                            </div>
                                        </div>
                                        {actionName?.name !== "Login Tool" &&
                                            <div className="form-row">
                                                <div className='form-col'>
                                                    <label className="form-label">Table Name<i>*</i></label>
                                                    <Controller
                                                        name={`tables`}
                                                        control={control}
                                                        defaultValue=""
                                                        rules={{
                                                            required: "Table Name is required"
                                                        }}
                                                        render={({ field }) => (
                                                            <InputText
                                                                {...field}
                                                                autoComplete="new-password"
                                                                style={{ border: errors.tables ? '1px solid #EC292E' : '' }}
                                                                onChange={e => { setValue("tables", e.target.value.replace(/\s/g, '')); clearErrors("tables") }}
                                                                placeholder='Enter your table name'
                                                            />
                                                        )}
                                                    />
                                                    {getFormErrorMessage("tables")}
                                                </div>
                                                {actionName?.name === "Product Search and Recommendation" &&
                                                    <div className='form-col'>
                                                        <label className="form-label">
                                                            Column Input List
                                                            <i>*</i>
                                                            <i
                                                                data-bs-toggle="modal"
                                                                className='ms-2'
                                                                data-bs-target="#Params-Info"
                                                                onClick={() => setModalContent("Defines the columns utilized as input features for generating embeddings, for example, productID.")}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                <img src={infoIcon} alt='info-icon' style={{ width: "16px" }} />
                                                            </i>
                                                        </label>
                                                        <Controller
                                                            name={`feature_column_list_input`}
                                                            control={control}
                                                            defaultValue=""
                                                            rules={{
                                                                required: "Column Input List is required"
                                                            }}
                                                            render={({ field }) => (
                                                                <InputText
                                                                    {...field}
                                                                    autoComplete="new-password"
                                                                    style={{ border: errors.feature_column_list_input ? '1px solid #EC292E' : '' }}
                                                                    onChange={e => { setValue("feature_column_list_input", e.target.value.replace(/\s/g, '')); clearErrors("feature_column_list_input") }}
                                                                    placeholder='Ex. column1,column2'
                                                                />
                                                            )}
                                                        />
                                                        {getFormErrorMessage("feature_column_list_input")}
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {actionName?.name === "Login Tool" && <>
                                            {<>{tables.length > 1 ? <>
                                                {tables.map((table: table_type, index: number) => (

                                                    <div className='form-row multi-row' key={index}>
                                                        <div className="form-col">
                                                            <label className="form-label">Table Name<i>*</i></label>
                                                            <InputText
                                                                type="text"
                                                                style={{ border: (errors as any)?.table_name && (errors as any)?.table_name[index]?.message ? '1px solid #EC292E' : '' }}
                                                                value={table.table_name}
                                                                {...register(`table_name.${index}`, {
                                                                    required: {
                                                                        value: true,
                                                                        message: `Table is required`,
                                                                    },
                                                                })}
                                                                onChange={(e) => handleChangeTableName(index, 'table_name', e.target.value)}
                                                            />
                                                            {(errors as any)?.table_name && (errors as any)?.table_name[index]?.message && (
                                                                <small className="p-error">{(errors as any)?.table_name[index]?.message}</small>
                                                            )}
                                                        </div>
                                                        <div className="form-col">
                                                            <label className="form-label">Column Name<i>*</i></label>
                                                            <InputText
                                                                type="text"
                                                                style={{ border: (errors as any)?.column_name && (errors as any)?.column_name[index]?.message ? '1px solid #EC292E' : '' }}
                                                                value={table.column_name}
                                                                {...register(`column_name.${index}`, {
                                                                    required: {
                                                                        value: true,
                                                                        message: `Column is required`,
                                                                    },
                                                                })}
                                                                onChange={(e) => handleChangeTableName(index, 'column_name', e.target.value)}
                                                            />
                                                            {(errors as any)?.column_name && (errors as any)?.column_name[index]?.message && (
                                                                <small className="p-error">{(errors as any)?.column_name[index]?.message}</small>
                                                            )}
                                                        </div>
                                                        {index === 0 &&
                                                            <i
                                                                className="row-action c-pointer"
                                                                onClick={addTableWithColumn}
                                                                style={{ pointerEvents: tables.length < 5 ? 'visible' : 'none', opacity: tables.length === 5 ? '0.5' : '' }}
                                                            >
                                                                <img src={plusIconSimple} alt='plus-icon' />
                                                            </i>
                                                        }
                                                        {index !== 0 && <i className="row-action-del c-pointer" onClick={() => removeColmnTable(index)}>
                                                            <img src={deleteDark} alt='delete-icon' />
                                                        </i>}
                                                    </div>
                                                ))}</>
                                                :
                                                <div className='form-row multi-row' key={0}>
                                                    <div className="form-col">
                                                        <label className="form-label">Table Name<i>*</i></label>
                                                        <InputText
                                                            type="text"
                                                            style={{ border: (errors as any)?.table_name && (errors as any)?.table_name[0]?.message ? '1px solid #EC292E' : '' }}
                                                            value={tables[0].table_name}
                                                            {...register(`table_name.${0}`, {
                                                                required: {
                                                                    value: true,
                                                                    message: `Table is required`,
                                                                },
                                                            })}
                                                            onChange={(e) => handleChangeTableName(0, 'table_name', e.target.value)}
                                                        />
                                                        {(errors as any)?.table_name && (errors as any)?.table_name[0]?.message && (
                                                            <small className="p-error">{(errors as any)?.table_name[0]?.message}</small>
                                                        )}
                                                    </div>
                                                    <div className="form-col">
                                                        <label className="form-label">Column Name<i>*</i></label>
                                                        <InputText
                                                            type="text"
                                                            style={{ border: (errors as any)?.column_name && (errors as any)?.column_name[0]?.message ? '1px solid #EC292E' : '' }}
                                                            value={tables[0].column_name}
                                                            {...register(`column_name.${0}`, {
                                                                required: {
                                                                    value: true,
                                                                    message: `Column is required`,
                                                                },
                                                            })}
                                                            onChange={(e) => handleChangeTableName(0, 'column_name', e.target.value)}
                                                        />
                                                        {(errors as any)?.column_name && (errors as any)?.column_name[0]?.message && (
                                                            <small className="p-error">{(errors as any)?.column_name[0]?.message}</small>
                                                        )}
                                                    </div>
                                                    <i
                                                        className="row-action c-pointer"
                                                        onClick={addTableWithColumn}
                                                        style={{ pointerEvents: tables.length < 5 ? 'visible' : 'none', opacity: tables.length === 5 ? '0.5' : '' }}
                                                    >
                                                        <img src={plusIconSimple} alt='plus-icon' />
                                                    </i>
                                                </div>
                                            }</>}

                                        </>}
                                        {/* {actionName?.name === "Login Tool" && tables.length > 0 && tables.map((table: table_type, index: number) => (
                                            <div className='form-row multi-row' key={index}>
                                                <div className="form-col">
                                                    <InputText
                                                        autoComplete="new-password"
                                                        value={table.table_name}
                                                        onChange={(e) => handleChangeTableName(index, 'table_name', e.target.value)}
                                                        placeholder='Enter your table name'
                                                    />
                                                    {errorsOfTable[index]?.table_name && (
                                                        <div style={{ color: 'red', fontSize: '14px' }}>{errorsOfTable[index].table_name}</div>
                                                    )}
                                                </div>
                                                <div className="form-col">
                                                    <InputText
                                                        autoComplete="new-password"
                                                        value={table.column_name}
                                                        onChange={(e) => handleChangeTableName(index, 'column_name', e.target.value)}
                                                        placeholder='Enter your column name'
                                                    />
                                                    {errorsOfTable[index]?.column_name && (
                                                        <div style={{ color: 'red', fontSize: '14px' }}>{errorsOfTable[index].column_name}</div>
                                                    )}
                                                </div>
                                                <i className="row-action-del c-pointer" onClick={() => removeColmnTable(index)}>
                                                    <img src={deleteDark} alt='delete-icon' />
                                                </i>
                                            </div>
                                        ))} */}
                                        {actionName?.name === "Product Search and Recommendation" &&
                                            <>
                                                <div className='form-row'>
                                                    <div className='form-col'>
                                                        <label className="form-label">
                                                            Column Output List
                                                            <i>*</i>
                                                            <i
                                                                data-bs-toggle="modal"
                                                                className='ms-2'
                                                                data-bs-target="#Params-Info"
                                                                onClick={() => setModalContent("Specifies the columns to be displayed in the UI, such as product details or ratings.")}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                <img src={infoIcon} alt='info-icon' style={{ width: "16px" }} />
                                                            </i>
                                                        </label>
                                                        <Controller
                                                            name={`feature_column_list_output`}
                                                            control={control}
                                                            defaultValue=""
                                                            rules={{
                                                                required: "Column Output List is required"
                                                            }}
                                                            render={({ field }) => (
                                                                <InputText
                                                                    {...field}
                                                                    autoComplete="new-password"
                                                                    style={{ border: errors.feature_column_list_output ? '1px solid #EC292E' : '' }}
                                                                    onChange={e => { setValue("feature_column_list_output", e.target.value.replace(/\s/g, '')); clearErrors("feature_column_list_output") }}
                                                                    placeholder='Ex. column1,column2'
                                                                />
                                                            )}
                                                        />
                                                        {getFormErrorMessage("feature_column_list_output")}
                                                    </div>
                                                    <div className='form-col'>
                                                        <label className="form-label">
                                                            Acceptance Threshold
                                                            <i>*</i>
                                                            <i
                                                                data-bs-toggle="modal"
                                                                className='ms-2'
                                                                data-bs-target="#Params-Info"
                                                                onClick={() => setModalContent("Determines the quality or relevance of results, e.g., 0.75.")}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                <img src={infoIcon} alt='info-icon' style={{ width: "16px" }} />
                                                            </i>
                                                        </label>
                                                        <Controller
                                                            name={`acceptance_threshold`}
                                                            control={control}
                                                            defaultValue=""
                                                            rules={{
                                                                required: "Acceptance Threshold is required",
                                                                validate: (value) => {
                                                                    if (value < 0 || value > 1) {
                                                                        return 'Acceptance Threshold must be between 0 and 1'
                                                                    }
                                                                    return true;
                                                                }
                                                            }}
                                                            render={({ field }) => (
                                                                <InputText
                                                                    {...field}
                                                                    onWheel={(e: any) => e.target.blur()}
                                                                    type='number'
                                                                    style={{ border: errors.acceptance_threshold ? '1px solid #EC292E' : '' }}
                                                                    autoComplete="new-password"
                                                                    placeholder="Enter your acceptance threshold"
                                                                    onChange={e => { setValue("acceptance_threshold", e.target.value); clearErrors("acceptance_threshold") }}
                                                                />
                                                            )}
                                                        />
                                                        {getFormErrorMessage("acceptance_threshold")}
                                                    </div>
                                                </div>
                                                <div className='form-row'>
                                                    <div className='form-col'>
                                                        <label className="form-label">Product Recommendation Prompt<i>*</i></label>
                                                        <Controller
                                                            name={`product_recommendation_tool`}
                                                            control={control}
                                                            defaultValue=""
                                                            rules={{
                                                                required: "Product Recommendation Prompt is required"
                                                            }}
                                                            render={({ field }) => (
                                                                <InputTextarea
                                                                    {...field}
                                                                    style={{ border: errors.product_recommendation_tool ? '1px solid #EC292E' : '' }}
                                                                    onChange={(e) => handleCustomChange(e, field, "product_recommendation_tool")}
                                                                />
                                                            )}
                                                        />
                                                        {getFormErrorMessage("product_recommendation_tool")}
                                                    </div>
                                                    <div className='form-col'>
                                                        <label className="form-label">
                                                            Max Search Results
                                                            <i>*</i>
                                                            <i
                                                                data-bs-toggle="modal"
                                                                className='ms-2'
                                                                data-bs-target="#Params-Info"
                                                                onClick={() => setModalContent("Indicates the number of top results to return, e.g., 6.")}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                <img src={infoIcon} alt='info-icon' style={{ width: "16px" }} />
                                                            </i>
                                                        </label>
                                                        <Controller
                                                            name={`top_n`}
                                                            control={control}
                                                            defaultValue=""
                                                            rules={{
                                                                required: "Max Search Results is required"
                                                            }}
                                                            render={({ field }) => (
                                                                <InputText
                                                                    {...field}
                                                                    onWheel={(e: any) => e.target.blur()}
                                                                    type='number'
                                                                    style={{ border: errors.top_n ? '1px solid #EC292E' : '' }}
                                                                    autoComplete="new-password"
                                                                    placeholder="Enter your max search result"
                                                                    onChange={e => { if (/^\d*$/.test(e.target.value)) { setValue("top_n", e.target.value); clearErrors("top_n") } }}
                                                                />
                                                            )}
                                                        />
                                                        {getFormErrorMessage("top_n")}
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </>
                                }
                                {actionName?.name === "Policy Tool" &&
                                    <div className='form-row'>
                                        <div className='form-col'>
                                            <label className="form-label">Return and Shipping Policy Prompt<i>*</i></label>
                                            <Controller
                                                name={`return_policy_tool`}
                                                control={control}
                                                defaultValue=""
                                                rules={{
                                                    required: "Return and Shipping Policy Prompt is required"
                                                }}
                                                render={({ field }) => (
                                                    <InputTextarea
                                                        {...field}
                                                        onChange={(e) => handleCustomChange(e, field, "return_policy_tool")}
                                                        style={{ border: errors.return_policy_tool ? '1px solid #EC292E' : '' }}
                                                    />
                                                )}
                                            />
                                            {getFormErrorMessage("return_policy_tool")}
                                        </div>
                                        <div className='form-col'>
                                            <label className="form-label">Policy File<i>*</i></label>
                                            <div className="form-field-wrap">
                                                <button type="button" className="file-btn" onClick={() => botRef.current.click()}>Choose File</button>
                                                <span className="file-label" title={uploadPolicyFileName}>{uploadPolicyFileName === "" ? "No file Chosen" : uploadPolicyFileName}</span>
                                                <Controller
                                                    name="upload_policy_file"
                                                    control={control}
                                                    defaultValue={[]}
                                                    rules={{
                                                        validate: {
                                                            required: (files) => files.length > 0 || "Policy File is required",
                                                        },
                                                    }}
                                                    render={({ field }) => (
                                                        <input
                                                            type="file"
                                                            accept=".pdf,.doc,.docx"
                                                            onChange={async (e: any) => {
                                                                if (e?.target?.files[0]) {
                                                                    if (["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(e?.target?.files[0]?.type)) {
                                                                        if (e?.target?.files[0].size < 5 * 1024 * 1024) {
                                                                            clearErrors("upload_policy_file");
                                                                            const base64Code: any = await myconst.fileToBase64(e?.target?.files[0])
                                                                            const correctBase64 = await myconst.manipulateBase64Data(base64Code);
                                                                            setValue("upload_policy_file", correctBase64);
                                                                            dispatch(setUploadPolicyFileName(e?.target?.files[0].name))
                                                                            field.onChange(correctBase64); // Update Controller state
                                                                        } else {
                                                                            botRef.current.value = null;
                                                                            toast.error("Policy File size must be less than 5MB", {
                                                                                style: {
                                                                                    backgroundColor: '#F1F1F1', // Grey background
                                                                                }
                                                                            })
                                                                        }
                                                                    } else {
                                                                        toast.error("Only PDF or DOCX files are allowed", {
                                                                            style: {
                                                                                backgroundColor: '#F1F1F1', // Grey background
                                                                            }
                                                                        })
                                                                        botRef.current.value = "";
                                                                    }
                                                                }
                                                            }}
                                                            ref={botRef}
                                                            id="botLogo"
                                                            className="d-none"
                                                        />
                                                    )}
                                                />
                                            </div>
                                            {getFormErrorMessage("upload_policy_file")}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div className='stepper-footer'>
                <div className='stepper-wrapper stepper-wrapper-ft'>
                    <div className='stepper-footer-inner'>
                        <div className='stepper-footer-left'>
                            <button type="button" disabled={items.length === 5} style={{ opacity: items.length === 5 ? "0.5" : "1" }} className={`${items.length === 5 ? "outline-active-btn" : "outline-icon-btn"} btn-lg mr-3`} onClick={handleAddAction}>Add More Action</button>
                        </div>
                        <div className='stepper-footer-right'>
                            <button type="button" className="grey-outline-btn mr-3" onClick={() => { handlePrev(); clearErrors(); }}>Previous</button>
                            <button type="button" className="outline-active-btn" onClick={handleNextButton}>Next</button>
                        </div>
                    </div>
                </div>
            </div>
            <ParamsPopUp content={modalContent} />
            <ConfirmDialog header="Confirmation" visible={visible} onHide={() => setVisible(false)} message={`Are you sure you want to delete ${del_action}?`}
                icon="pi pi-exclamation-triangle" accept={() => removeItem(del_action)} reject={reject} />
        </div >
    )
}
export default StepTwo;